import { useMemo } from 'react'

import { type Clinic, getClinics } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'

/**
 * Returns the clinics in the active region, for region-scoped clinic pickers
 * (so e.g. the US clinic is hidden while the UK region is active).
 */
export function useRegionClinics({
  includeArchived = false,
}: {
  includeArchived?: boolean
} = {}): Clinic[] {
  const { region } = useViewerRegion()
  return useMemo(
    () => getClinics({ includeArchived }).filter((c) => c.region === region),
    [includeArchived, region]
  )
}
